import * as React from "react";
import { cn } from "@/lib/utils";

const badgeVariants = {
  default: "border-transparent bg-[var(--color-primary)] text-[var(--color-primary-foreground)]",
  secondary: "border-transparent bg-[var(--color-secondary)] text-[var(--color-secondary-foreground)]",
  destructive: "border-transparent bg-[var(--color-destructive)] text-[var(--color-destructive-foreground)]",
  outline: "text-[var(--color-foreground)] border-[var(--color-border)]",
  success: "border-transparent bg-emerald-100 text-emerald-700",
  warning: "border-transparent bg-amber-100 text-amber-800",
};

type BadgeProps = React.HTMLAttributes<HTMLSpanElement> & {
  variant?: keyof typeof badgeVariants;
};

function Badge({ className, variant = "default", ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)] focus:ring-offset-2",
        badgeVariants[variant],
        className
      )}
      {...props}
    />
  );
}

export { Badge, type BadgeProps };
